(function(){
     'use strict';

     angular
        .module('appback')
        .factory('PreanaliticaService', PreanaliticaService);

    PreanaliticaService.$inject = ['$http'];

    function PreanaliticaService($http){


        var service= {
           getPeticion:getPeticion,
           getGrid:getGrid,
           cambiarPendiente:cambiarPendiente,
           getLlegada:getLlegada,
           saveAmpliacion:saveAmpliacion,
           marcarLLegada:marcarLLegada,
           cambiarLab:cambiarLab,
           getAlic:getAlic,
           saveAlic:saveAlic,
           getTrazabilidadMuestra:getTrazabilidadMuestra
        };

        return service;
        function getPeticion(peticion_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preanalitica/getpeticion', { params : { peticion_id:peticion_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function getTrazabilidadMuestra(peticion_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preanalitica/gettrazabilidadmuestra', { params : { peticion_id:peticion_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function saveAlic(vm,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            var data = $.param({ 
                peticion_id:vm.peticion_id,
                muestrasEstados:JSON.stringify(vm.muestrasEstados), 
            });
            $http.post('/backend/preanalitica/savealic',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function getAlic(peticion_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preanalitica/getalicuota', { params : { peticion_id:peticion_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function marcarLLegada(lab_id,peticion_id,vm,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            var data = $.param({ 
                muestrasEstados:JSON.stringify(vm.muestrasEstados), 
                peticion_id:peticion_id, 
                lab_id:lab_id, 
                destinatario:vm.peticion.destinatario,
                carta:JSON.stringify(vm.peticion.carta),
                comentario:vm.peticion.comentariouranolab
            });
            $http.post('/backend/preanalitica/marcarllegada',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }

        function cambiarLab(itemsClick,laboratorio_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
           
            var data = $.param({ 
                laboratorio_id:laboratorio_id, 
                itemsClick:JSON.stringify(itemsClick), 
            });
            $http.post('/backend/preanalitica/cambiarlab',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
        

        function getLlegada(peticion_id,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preanalitica/getllegada', { params : { peticion_id:peticion_id}  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
        
        function cambiarPendiente(peticion,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var analiticasNoPueden = [];
            for(var cont2=0;cont2<peticion.analiticas.length;cont2++){
                for(var cont=0;cont<peticion.analiticas[cont2].preanalitica_lab.analiticasNoPueden.length;cont++){
                    analiticasNoPueden.push({ peticion_id:peticion.analiticas[cont2].id, analitica_id : peticion.analiticas[cont2].preanalitica_lab.analiticasNoPueden[cont].id, lab_enviar:peticion.analiticas[cont2].preanalitica_lab.analiticasNoPueden[cont].lab_enviar});
                }
            }

            var analiticasPueden = [];
            for(var cont2=0;cont2<peticion.analiticas.length;cont2++){
                for(var cont=0;cont<peticion.analiticas[cont2].preanalitica_lab.analiticasPueden.length;cont++){
                    analiticasPueden.push({ peticion_id:peticion.analiticas[cont2].id, analitica_id : peticion.analiticas[cont2].preanalitica_lab.analiticasPueden[cont].id, lab_enviar:peticion.analiticas[cont2].preanalitica_lab.analiticasPueden[cont].lab_enviar});
                }
            }

            var data = $.param({ 
                peticion_id:peticion.id, 
                comentario:peticion.comentariouranolab,
                tracking:peticion.tracking,
                analiticasNoPueden:JSON.stringify(analiticasNoPueden), 
                analiticasPueden:JSON.stringify(analiticasPueden), 
                tipomuestra_id:JSON.stringify(peticion.tipomuestra_id), 
                tiposestados:JSON.stringify(peticion.tiposestados), 
                urgente:peticion.urgente ,
                destinatario:peticion.destinatario,
                carta:JSON.stringify(peticion.carta)
            });
            $http.post('/backend/preanalitica/cambiarpendiente',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
        function saveAmpliacion(peticion,callback)
        {

            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var analiticasNoPueden = [];
            for(var cont=0;cont<peticion.preanalitica_lab.analiticasNoPueden.length;cont++){
                analiticasNoPueden.push({ analitica_id : peticion.preanalitica_lab.analiticasNoPueden[cont].id, lab_enviar:peticion.preanalitica_lab.analiticasNoPueden[cont].lab_enviar});
            }

            var analiticasPueden = [];
            for(var cont=0;cont<peticion.preanalitica_lab.analiticasPueden.length;cont++){
                analiticasPueden.push({ analitica_id : peticion.preanalitica_lab.analiticasPueden[cont].id, lab_enviar:peticion.preanalitica_lab.analiticasPueden[cont].lab_enviar});
            }

            var data = $.param({ 
                peticion_id:peticion.id, 
                analiticasNoPueden:JSON.stringify(analiticasNoPueden), 
                analiticasPueden:JSON.stringify(analiticasPueden)
            });
            $http.post('/backend/preanalitica/saveampliacion',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
        function getGrid(callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/preanalitica/getgrid', { params : { }  }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
            
        }
    }
})();